export default __webpack_public_path__ + "static/media/WNo.6-4.494e7159.jpg";